import { useUnreadContactCount as useUnreadContactCountQuery } from "@/api/services/admin/contact";
import { EVENTS } from "@/constants/socket";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useContext } from "react";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { SocketContext } from "@/providers/SocketProvider";

export const useUnreadContactCount = () => {
  const queryClient = useQueryClient();
  const { data: unreadCount = 0, refetch } = useUnreadContactCountQuery();

  const socketContext = useContext(SocketContext);
  const socket = socketContext?.socket || null;

  useEffect(() => {
    if (!socket) return;

    const handleNewContact = () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.CONTACT.UNREAD_COUNT] });
      refetch();
    };

    socket.on(EVENTS.CONTACT.NEW_CONTACT, handleNewContact);

    return () => {
      socket.off(EVENTS.CONTACT.NEW_CONTACT, handleNewContact);
    };
  }, [socket, queryClient, refetch]);

  return { unreadCount, hasUnread: unreadCount > 0 };
};
